import { Component, ViewEncapsulation, Input } from '@angular/core';

import { ProgressBar, Block, User } from 'shared-stuff';
import { Observable, Subscription } from 'rxjs';
import { columnHeaders } from 'app/views/user/column.headers';
import { AngularFirestore } from '@angular/fire/firestore';

@Component({
  selector: 'program-progress',
  templateUrl: './program-progress-bar.component.html',
  encapsulation: ViewEncapsulation.None
})
export class ProgramProgressBar {
  @Input('user') set user(_user: User) {
    this.currentUser = _user;
    if (_user) {
      const progressBarDocId = _user.progress
      if (progressBarDocId != null) {
        this.progressDoc$ = this.db.doc<ProgressBar>(`progressBars/${progressBarDocId}`).valueChanges()
        this.subs.add(this.progressDoc$.subscribe(bars => {
          this.progressBars = bars
        }))
      }
    }
  };
  currentUser: User;
  subs = new Subscription();
  progressDoc$: Observable<ProgressBar>
  // progress bar documentation:
  // https://valor-software.com/ngx-bootstrap/#/progressbar
  // types: success (green), info (blue), warning (yellow), danger (red)
  // max value is specified in template
  columnHeaders: Block[] = columnHeaders
  progressBars: ProgressBar = {
    // initial state is used to reduce errors, once a user is passed in
    carpentry: this.columnHeaders,
    concrete: this.columnHeaders,
    construction: this.columnHeaders,
    electrical: this.columnHeaders,
    heo: this.columnHeaders,
    hvac: this.columnHeaders,
    hfi: this.columnHeaders,
    plumbing: this.columnHeaders,
    roofing: this.columnHeaders,
    sheet: this.columnHeaders,
    sprinkler: this.columnHeaders,
    steam: this.columnHeaders,
  }

  constructor(
    private db: AngularFirestore,
  ) { }

  public getProgressBar(program: string): Block[] {
    return this.progressBars[program]
  }

}



// WEBPACK FOOTER //
// /Users/elliot/code/abc-angular/src/app/core/program-progress-bar.component.ts